import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "chip";
var attributes = {
    TYPE: 'type',
    SELECTED: 'selected',
    VALUE: 'value',
    DISABLED: 'disabled',
    INVALID: 'invalid',
    DENSE: 'dense',
};
var classes = {
    ACTION: 'tyl-chip--action',
    CHOICE: 'tyl-chip--choice',
    FILTER: 'tyl-chip--filter',
    INPUT: 'tyl-chip--input',
    FIELD: 'tyl-chip--field',
    INVALID: 'tyl-chip--invalid',
    SELECTED: 'tyl-chip--selected',
    DELETE_BUTTON: 'tyl-chip__delete-button',
    DELETE_BUTTON_TOUCH_TARGET: 'tyl-chip__delete-button__touch-target',
    DENSE: 'tyl-chip--dense',
    LEADING_HIDDEN: 'tyl-chip__leading--hidden'
};
var selectors = {
    BUTTON: 'button.tyl-chip'
};
var events = {
    DELETE: elementName + "-delete",
    SELECT: elementName + "-select"
};
var defaults = {
    TYPE: 'action'
};
export var CHIP_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    classes: classes,
    selectors: selectors,
    events: events,
    defaults: defaults
};
